/** What the New batch dialog sends as `params`, and when Create is allowed.
 *  Kept pure so the rules are testable without driving the MUI selects. */

export interface BatchParamsInput {
  mode: "auto" | "explicit";
  type: "invoice_audit" | "run_skill";
  skillName: string;
  prompt: string;
  contractMode: "none" | "shared" | "per_invoice";
  sharedContract: string;
}

export function explicitParamsValid(i: BatchParamsInput): boolean {
  if (i.mode !== "explicit") return true;
  if (i.type === "run_skill") return Boolean(i.skillName.trim() || i.prompt.trim());
  return i.contractMode !== "shared" || Boolean(i.sharedContract);
}

export function buildBatchParams(i: BatchParamsInput): Record<string, unknown> {
  if (i.mode !== "explicit") return {};
  if (i.type === "invoice_audit") {
    const params: Record<string, unknown> = { contract_mode: i.contractMode };
    if (i.contractMode === "shared") params.shared_contract_filename = i.sharedContract;
    return params;
  }
  const params: Record<string, unknown> = {};
  if (i.skillName.trim()) params.skill_name = i.skillName.trim();
  if (i.prompt.trim()) params.prompt = i.prompt.trim();
  return params;
}
